import "../../localization/arabic";
import "../../localization/basque";
import "../../localization/bulgarian";
import "../../localization/catalan";
import "../../localization/croatian";
import "../../localization/czech";
import "../../localization/danish";
import "../../localization/dutch";
import "../../localization/nl-BE";
import "../../localization/estonian";
import "../../localization/finnish";
import "../../localization/french";
import "../../localization/georgian";
import "../../localization/german";
import "../../localization/greek";
import "../../localization/hebrew";
import "../../localization/hindi";
import "../../localization/hungarian";
import "../../localization/icelandic";
import "../../localization/indonesian";
import "../../localization/italian";
import "../../localization/japanese";
import "../../localization/kazakh";
import "../../localization/korean";
import "../../localization/latvian";
import "../../localization/lithuanian";
import "../../localization/macedonian";
import "../../localization/norwegian";
import "../../localization/persian";
import "../../localization/polish";
import "../../localization/portuguese";
import "../../localization/portuguese-br";
import "../../localization/romanian";
import "../../localization/russian";
import "../../localization/serbian";
import "../../localization/simplified-chinese";
import "../../localization/spanish";
import "../../localization/swahili";
import "../../localization/swedish";
import "../../localization/tajik";
import "../../localization/thai";
import "../../localization/traditional-chinese";
import "../../localization/turkish";
import "../../localization/ukrainian";
import "../../localization/vietnamese";
import "../../localization/welsh";
